import { jsx as _jsx } from "react/jsx-runtime";
import PlaceholderLogo from '../assets/placeholder-logo.svg';
import * as S from './styles';
export function LoadingPagePlaceholder() {
    return (_jsx(S.Container, { children: _jsx(S.Logo, { children: _jsx(PlaceholderLogo, {}) }) }));
}
